module.exports = __webpack_public_path__ + "static/media/bgDotted.656cb5ad.png";